import React from 'react';
import { useQuery } from '@apollo/client';
import GET_ORG_INFO from '@shared/queries/getOrgInfoQuery';
import ApolloError from '@shared/components/ApolloError';
import SkeletonWrapper from '@shared/components/skeleton/SkeletonWrapper';
import StrengthsAndChallenges from '../../strengthsAndChallenges/components/StrengthsAndChallenges';

/**
 * @typedef {object} OrgStrengthsAndChallengesProps
 * @property {number} orgId
 * @property {string} [orgName]
 */

/**
 * @param {OrgStrengthsAndChallengesProps} props
 */
const OrgStrengthsAndChallenges = props => {
  const { orgId } = props;

  const {
    data: orgInfo,
    error: orgInfoError,
    loading: orgInfoLoading
  } = useQuery(GET_ORG_INFO, {
    variables: { id: orgId }
  });

  const orgName = orgInfo?.mddapOrganization.Name || '';

  if (orgInfoError) {
    return <ApolloError />;
  }

  return (
    <SkeletonWrapper show={orgInfoLoading}>
      <StrengthsAndChallenges
        orgId={orgId}
        title={`Strengths and Challenges for ${orgName}`}
        description={description}
      />
    </SkeletonWrapper>
  );
};

const description =
  'This report provides the Organization Strengths and Challenges. The report can be filtered ' +
  'by selecting one of the views. The report defaults to the Baseline view, ' +
  'which displays the list of practices that were determined to be Strengths or ' +
  'Challenges based on the result from the first instance in which they were evaluated ' +
  '(the first instance may not have occurred in the first year). ' +
  'The delta view allows for a comparison between two instances. ' +
  'Use the delta instance selector to choose which instances to compare. ' +
  'The total view represents Strengths and Challenges across all instances. ' +
  'The OHT(s) selection can be used to filter the results further. ' +
  'If there are not enough results for a practice, then it will not be displayed in the table.';

export default OrgStrengthsAndChallenges;
